export default __webpack_public_path__ + "static/media/notice_icon.70b7d7ce.svg";